<template>
  <div class="l-row">
    <price-status :module="module" @change="onChange"/>
  </div>
</template>

<script>
  import PriceStatus from '@/components/tool/batch/shared/filters/marketplace/PriceStatus'
  import { merge } from 'lodash'

  export default {
    data: () => ({
      filters: null
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      }
    },
    components: {
      PriceStatus
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Gfg.vue?6be76200